__turbopack_context__.v({
  "main": "ErrorPage-module-scss-module__cyS-qq__main",
  "page": "ErrorPage-module-scss-module__cyS-qq__page",
  "textBlock": "ErrorPage-module-scss-module__cyS-qq__textBlock",
});
